import { SEO } from "../components/SEO";
import techGuyDomLogo from "../images/logos/TechGuyDomCropped.svg";
import azureArchCert from "../images/certifications/Azure_Arch.png";
import ccnpCert from "../images/certifications/CCNP.jpg";
import mcseCloudCert from "../images/certifications/MCSE_Cloud_Platform.png";
import isacaCismCert from "../images/certifications/ISACA_CISM.png";
import isc2SscpCert from "../images/certifications/ISC2_SSCP.png";

const competencies = [
  {
    title: "AI Strategy & Governance",
    text: "Designing responsible AI frameworks, ethical guardrails, and organizational AI usage policies that ensure data privacy, compliance, and alignment with business risk standards.",
  },
  {
    title: "Agentic AI & LLM Integration",
    text: "Architecting and deploying agentic AI workflows using LLMs to automate code review, test-case generation, and release documentation—accelerating delivery and freeing teams for higher-value work.",
  },
  {
    title: "Cloud Architecture (Azure)",
    text: "Azure Solutions Architect Expert certified. Experienced in designing and scaling cloud platforms, leading compliance initiatives, and implementing enterprise-grade infrastructure with high availability.",
  },
  {
    title: "Cybersecurity Leadership",
    text: "CISM and SSCP certified. Hands-on experience with DAST (OWASP ZAP, Web Dojo), penetration testing, PCI/HIPAA compliance, and secure SDLC practices across regulated industries.",
  },
  {
    title: "Identity & Access Management",
    text: "Engineered and deployed cloud-based SSO solutions on Azure using modern MSAL frameworks, integrating external identity providers to reduce vulnerabilities across all access points.",
  },
  {
    title: "Regulatory Compliance",
    text: "Proven experience driving compliance initiatives including SOC 2, Sarbanes-Oxley, SAE 16, PCI, and HIPAA—implementing structured security protocols and documentation under real-world constraints.",
  },
  {
    title: "Enterprise Networking",
    text: "Cisco CCNP certified. Designed and scaled enterprise network infrastructure including on-premises data centers with virtualization, cybersecurity modernization, and custom IDS deployments.",
  },
  {
    title: "Remote IT Support",
    text: "Fast, secure, encrypted remote diagnostics and repair for individuals and businesses across Windows, macOS, and Linux—no travel fees, no wait.",
  },
  {
    title: "Domain & Hosting",
    text: "Affordable domain registration and premium hosting with hands-on DNS configuration, SSL setup, and ongoing management support tailored to your needs.",
  },
];

export const About = () => {
  return (
    <>
      <SEO
        title="About TechGuyDom — Technology Leader & Trusted IT Partner"
        description="Led by Dominic, a senior technology executive with 20+ years in software, cloud architecture, AI, and cybersecurity. Azure Architect, CISM, SSCP, CCNP certified."
        path="/about"
      />
      {/* Page Header */}
      <div className="page-header-section">
        <h1>About TechGuyDom</h1>
        <p className="page-header-sub">
          Technology leader. Trusted IT partner. Practical problem-solver.
        </p>
      </div>

      <div className="container about-section">
        {/* Bio Row */}
        <div className="row g-5 align-items-start">
          <div className="col-md-3 text-center">
            <img
              src={techGuyDomLogo}
              alt="TechGuyDom"
              className="about-logo"
            />
          </div>
          <div className="col-md-9">
            <h3 className="section-title mt-0">Who Is TechGuyDom?</h3>
            <p>
              TechGuyDom is led by Dominic, an accomplished technology
              executive with over two decades of experience driving software
              development, infrastructure modernization, and regulatory
              compliance across diverse industries. With a career built at the
              intersection of innovation and reliability, Dominic has led
              engineering organizations at scale—delivering measurable gains in
              productivity, system stability, and team performance.
            </p>
            <p>
              As a senior technology leader, Dominic has architected and
              deployed agentic AI pipelines, integrated predictive analytics
              into various platforms serving a diverse set of use cases,
              achieved SOC 2 certification for Azure cloud environments, and
              built cloud-based SSO solutions that secured enterprise access
              points across regulated industries. That same depth of experience
              is now available directly to individuals, small businesses, and
              organizations that deserve world-class technology without the
              enterprise overhead.
            </p>
            <p>
              Whether you need a quick remote fix, trusted guidance on AI
              adoption, a cloud architecture that actually scales, or a
              security posture that meets compliance requirements—TechGuyDom
              is your go-to resource.
            </p>
          </div>
        </div>

        <hr className="section-divider" />

        {/* Core Competencies */}
        <div className="row g-4 pt-3">
          <div className="col-12 text-center">
            <h3 className="section-title mt-4">Core Competencies</h3>
          </div>
          {competencies.map((item, i) => (
            <div className="col-md-4" key={i}>
              <div className="competency-card">
                <h6>{item.title}</h6>
                <p>{item.text}</p>
              </div>
            </div>
          ))}
        </div>

        <hr className="section-divider" />

        {/* Certifications */}
        <div className="text-center mb-5 pt-3">
          <h3 className="section-title mt-4">Certifications</h3>
          <div className="cert-badges">
            <img
              src={ccnpCert}
              alt="CCNP"
              className="cert-badge"
              style={{ maxHeight: "110px" }}
            />
            <img
              src={azureArchCert}
              alt="Azure Architect"
              className="cert-badge"
              style={{ maxHeight: "80px" }}
            />
            <img
              src={mcseCloudCert}
              alt="MCSE Cloud"
              className="cert-badge"
              style={{ maxHeight: "80px" }}
            />
            <img
              src={isacaCismCert}
              alt="ISACA CISM"
              className="cert-badge"
              style={{ maxHeight: "80px" }}
            />
            <img
              src={isc2SscpCert}
              alt="ISC2 SSCP"
              className="cert-badge"
              style={{ maxHeight: "80px" }}
            />
          </div>
        </div>
      </div>
    </>
  );
};
